<template>
	<div>
		<div class="row" v-bind:style="cstyle">
			<!-- <button @click="newRelation()">Click Mir</button> -->
			<div v-bind:class="searchClass">
				<div class="input-group">
					<span class="input-group-btn" v-if="hasSearch">
						<button tabindex="-1" type="button" class="btn btn-default" @click="clearSearch()"><i class="fa fa-times"></i></button>
					</span>
					<input type="text" class="form-control" placeholder="Suchen ..." id="deceased-search" v-model="searchValue"  v-if="hasSearch">
					<div class="input-group-btn search-criteria-select-container" v-if="hasSearch">
						<button tabindex="-1" data-toggle="dropdown" class="btn btn-default dropdown-toggle" type="button">
						<span class="caret"></span>
							<span class="sr-only">Dropdown</span>
						</button>
						<ul class="dropdown-menu">
							<li><a style="cursor: pointer" class="small" tabindex="-1" @click.stop="exactValue = !exactValue"><input v-model="exactValue" type="checkbox" syle="display: block;" value="Exakte Übereinstimmung" name="exaktValueCheckbox" />&nbsp;Exakten Wert</a></li>
							<li class="divider"></li>
							<li><a style="cursor: pointer" @click.stop="andSearchMode = !andSearchMode">Modus: {{ andSearchMode ? 'UND' : 'ODER' }}</a></li>
							<li><a style="cursor: pointer" @click.stop="inclusiveSearchMode = !inclusiveSearchMode">Modus: {{ inclusiveSearchMode ? 'Suchen' : 'Ignorieren' }}</a></li>
							<li class="divider"></li>
							<li><a @click.stop="selectAll()" style="cursor: pointer">Alles auswählen</a></li>
							<li><a @click.stop="selectNone()" style="cursor: pointer">Alles abwählen</a></li>
							<li><a @click.stop="selectInverse()" style="cursor: pointer">Auswahl umkehren</a></li>
							<li class="divider"></li>
							<li v-for="currCriteria in criterias">
								<a style="cursor: pointer" class="small" tabindex="-1"@click.stop="toggleChecked(currCriteria)"><input v-model="currCriteria.checked" type="checkbox" syle="display: block;" />&nbsp;{{currCriteria.name}}</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="col-xs-2" v-if="hasAddButton || hasPrintButton">
				<a class="btn btn-primary pull-right" :href="addURL === '' ? null : addURL" @click="$emit('add')" v-if="hasAddButton"><i class="fa fa-plus"></i></a>
				<span class="btn btn-success pull-right" @click="$emit('print', printModels())" v-if="hasPrintButton"><i class="fa fa-print"></i></span>
			</div>
		</div>

		<div class="row">
			<br>
			<div class="col-lg-12" v-if="filteredModel.length > 0">
				Zeige
				<select v-model="rowMeter">
					<option value="5" v-if="entryCount >= 5">5</option>
					<option value="10" v-if="entryCount >= 10">10</option>
					<option value="20" v-if="entryCount >= 20">20</option>
					<option value="50" v-if="entryCount >= 50">50</option>
					<option value="100" v-if="entryCount >= 100">100</option>
					<option value="200" v-if="entryCount >= 200">200</option>
					<option value="500" v-if="entryCount >= 500">500</option>
					<option value="0">Alle</option>
				</select>
				von {{ filteredModel.length }} Einträgen pro Seite {{ selectText }}
			</div>
		</div>

		<div class="row">
			<br>
			<div class="col-xs-12">
				<table class="table table-striped table-hover">
					<thead>
						<tr>
							<th v-if="hasMultiSelect" @click="togglePageCheck()"><span :class="checkClass"></span></th>
							<th v-if="hasSort" v-for="col in cols" @click="setSortBy(col.json)" :class="parseCSS(col)" style="parseStyle(col)">
								<span v-bind:class="col.style" style="margin-right: 5px;"></span>{{ col.name }}
								<div class="custom_tooltip" v-if="typeof col.hint === 'string' && col.hint !== ''"><span class="fa fa-info-circle"></span>
									<div class="custom_tooltiptext">
										<div v-for="line in col.hint.split('<br>')">{{ line }}</div>
									</div>
								</div>
							</th>
							<th v-if="!hasSort" v-for="col in cols" :class="parseCSS(col)">&nbsp;
								{{ col.name }}
								<div class="custom_tooltip" v-if="typeof col.hint === 'string' && col.hint !== ''"><span class="fa fa-info-circle"></span>
									<div class="custom_tooltiptext">
										<div v-for="line in col.hint.split('<br>')">{{ line }}</div>
									</div>
								</div>
							</th>
							<th v-if="hasRowButtons">&nbsp;</th>
						</tr>
					</thead>

					<tbody>
						<tr v-for="model in allModels">
							<td v-if="hasMultiSelect" @click="toggleModelChecked(model)"><span :class="model['_checked'] === false ? 'fa fa-square-o' : 'fa fa-check-square-o'"></span></td>
							<td v-for="col in cols" :class="parseCSS(col, model)" :style="parseStyle(col, model)" @click="toggleModelChecked(model)">
								<p v-for="line in parse(col.type, model[col.json], col, model)">
									<span v-if="col.type !== 'url'" :class="parseColCSS(col, model[col.json], model)" :style="parseColStyle(col, model[col.json])">{{ line }}</span>
								</p>
								<a v-if="col.type === 'url'" :href="parse(col.type, model, col)">Link</a>
							</td>
							<td v-if="hasRowButtons">
								<span class="pull-right">
									<span :class="rowSpanClass" style="text-align: right" v-if="hasDelButton">
										<a class="btn btn-danger btn-sm" :href="delURL === '' ? null : delURL | parseURL(model)" @click="$emit('delete', model)"><i class="fa fa-trash"></i></a>
									</span>

									<span :class="rowSpanClass" style="text-align: right" v-if="hasEditButton">
										<a class="btn btn-primary btn-sm" :href="editURL === '' ? null : editURL | parseURL(model)" @click="$emit('edit', model)"><i class="fa fa-pencil"></i></a>
									</span>

									<span :class="rowSpanClass" style="text-align: right" v-if="hasSelectButton">
										<a class="btn btn-success btn-sm" :href="selURL === '' ? null : selURL | parseURL(model)" @click="$emit('select', model)"><i class="fa fa-arrow-right"></i></a>
									</span>

									<span :class="rowSpanClass" style="text-align: right" v-if="hasRowAddButton">
										<a class="btn btn-success btn-sm" :href="selURL === '' ? null : selURL | parseURL(model)" @click="$emit('rowAdd', model)"><i class="fa fa-plus"></i></a>
									</span>
								</span>
							</td>
						</tr>

					</tbody>

					<tfoot v-if="pageCount > 1">
						<td :colspan="colCount" style="text-align: center">
							<nav aria-label="Page navigation">
								<ul class="pagination">
									<li class="active" v-if="page > 2"><a @click="firstPage()" aria-label="First" class="fa fa-step-backward"></a></li>
									<li  v-for="index in pageBefore"><a @click="setPage(index)">{{ parseInt(index) + 1 }}</a></li>

									<li class="active"><a>{{ parseInt(page) + 1 }}</a></li>

									<li v-for="index in pageAfter"><a @click="setPage(index)">{{ index + 1 }}</a></li>
									<li class="active" v-if="page < pageCount - 3"><a @click="lastPage()" class="fa fa-step-forward"></a></li>
								</ul>
							</nav>
						</td>
					</tfoot>
				</table>
			</div>
		</div>

		<div class="row" v-if="hasMultiSelect">
			<div class="col-lg-12">
				<button @click="sendMultiSelect" class="btn btn-primary pull-right" :disabled="selectedItemCount === 0">{{ multiselectText }}</button>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
import _ from 'underscore'
//import pdfMake from 'pdfmake'

export default {
	template: '#table',

	model: {
		prop: 'targetModel',
		event: 'change'
	},

	props: {
		targetModel: Array,
		cols: Array,
		criteria: Array,
		cstyle: String,
		search: String,
		defSearch: {
			type: String,
			default: ''
		},
		srcModel: Array,
		nosort: String,
		defaultSort: {
				type: Object,
				default () {
					return {
						col: '',
						order: ''
					}
				}
		},

		add: String,
		select: String,
		edit: String,
		delete: String,
		multiselect: String,
		rowAdd: String,
		print: String,

		rowCount: {
			type: Number,
			default: 0
		},

		sendCriteria: {
			type: Boolean,
			default: false
		}
	},

	data () {
		return {
			deceaseds: [],
			searchValue: '',
			sortBy: '',
			sortAsc: 1,
			sortDesc: -1,
			criterias: [],
			models: [],
			page: 0,
			rowMeter: 10,
			rowMeterStarted: false,
			exactValue: false,
			rowMeterEmptyValue: 10,
			rowMeters: [],
			oldSearchValue: '',
			andSearchMode: false,
			inclusiveSearchMode: true,
			collection: []
		}
	},

	mounted () {
		var col

		this.collection = this.srcModel.map((Item, Index) => {
			let result = Item
			if (typeof result["_checked"] === 'undefined') {
				result["_checked"] = false
			}
			result['_id'] = Index
			result['_visible'] = false
			return result
		})

		this.searchValue = this.defSearch

		this.sortBy = this.defaultSort.col
		this.sortAsc = this.defaultSort.order === 'asc'

		for (col in this.cols) {
			if (this.cols[col].json === this.sortBy) {
				this.cols[col].style = this.sortAsc === true ? 'fa fa-sort-asc' : 'fa fa-sort-desc'
			} else {
				this.cols[col].style = 'fa fa-sort'
			}
		}

		if (typeof this.criteria === 'undefined' || this.criteria.length === 0) {
			this.cols.forEach(col => {
				this.criterias.push({ name: col.name, json: col.json, checked: true })
			})
		} else {
			this.criteria.forEach(currCriteria => {
				this.criterias.push({ name: currCriteria.name, json: currCriteria.json, checked: true })
			})
		}
	},

	watch: {
		searchValue (newSearchValue) {
			if (newSearchValue.length > this.oldSearchValue.length && newSearchValue !== '') {
				this.rowMeters.push(this.rowMeter)
			} else if (newSearchValue.length < this.oldSearchValue.length && newSearchValue !== '') {
				this.rowMeter = this.rowMeters.pop()
			}

			this.oldSearchValue = newSearchValue
		},

		srcModel () {
			this.collection = this.srcModel.map((Item, Index) => {
  				let result = Item
				if (typeof result["_checked"] === 'undefined') {
					result["_checked"] = false
				}
				result['_id'] = Index
				result['_visible'] = false
				return result
			})
		}
	},

	methods: {
		getModels () {
			return this.allModels
		},

		toggleModelChecked (model) {
			if (typeof model === 'undefined') {
				return
			}

			if (!this.hasMultiSelect) {
				return
			}

			this.collection = this.collection.map(Item => {
				let result = Item
				if (model['_id'] === result['_id']) {
		  			result["_checked"] = !result["_checked"]
				}
				return result
	  		})
		},

		togglePageCheck () {
			if (!this.hasMultiSelect) {
				return
			}
			const checkMode = !this.allModels.some(Item => Item['_checked'])

			// console.log('START')
			this.collection = this.collection.map((Item, Index) => {
				let result = Item
				if (Item['_visible'] === true) {
					// console.log(Item['name'])
					result['_checked'] = checkMode
				}
				return result
	  		})
			// console.log('END')
		},

		nextHighest (aValue, aSource) {
			let Index

			for (Index in aSource) {
				if (parseInt(aValue) < parseInt(aSource[Index])) {
					return parseInt(aSource[Index])
				}
			}
		},

		nextLowest (aValue, aSource) {
			let Index

			for (Index in aSource) {
				if (parseInt(aValue) > parseInt(aSource[Index])) {
					return parseInt(aSource[Index])
				}
			}
		},

		printModels () {
			let result = this.allModels.map((aValue) => {
				let mapResult = []
				let col

				this.cols.forEach(col => {
					mapResult.push(aValue[col.json])
				})

				return mapResult
			}, this)

			let headLine = this.cols.map((aValue) => {
				return aValue.name
			}, this)

			result.unshift(headLine)

			return result
		},

		parseColCSS (aCol, aValue, aModel) {
			let result = null

			if (typeof aCol.css === 'undefined' || aCol.css === null) {
				return null
			}

			if (typeof aCol.css === 'function') {
				return aCol.css(aValue, aCol, aModel)
			}

			if (typeof aCol.css.default !== 'undefined') {
				result = aCol.css.default
			}

			if (typeof aCol.css[aValue] !== 'undefined') {
				result = aCol.css[aValue]
			}

			return typeof result === 'function' ? result(aValue) : result
		},

		parseColStyle (aCol, aValue) {
			let result = null

			if (typeof aCol.inline === 'undefined' || aCol.inline === null) {
				return null
			}

			if (typeof aCol.inline === 'function') {
				return aCol.inline(aValue, aCol)
			}

			if (typeof aCol.inline.default !== 'undefined') {
				result = aCol.inline.default
			}

			if (typeof aCol.inline[aValue] !== 'undefined') {
				result = aCol.inline[aValue]
			}

			return typeof result === 'function' ? result(aValue, aCol) : result
		},

		nextPage () {
			this.page = this.page + 1
			if (this.page >= this.pageCount) {
				this.page = this.pageCount - 1
			}
		},

		prevPage () {
			this.page = this.page - 1
			if (this.page <= -1) {
				this.page = 0
			}
		},

		firstPage () {
			this.page = 0
		},

		lastPage () {
			this.page = this.pageCount - 1
		},

		setPage (aPage) {
			this.page = parseInt(aPage)
			if (this.page >= this.pageCount) {
				this.page = this.pageCount - 1
			}
			if (this.page <= -1) {
				this.page = 0
			}
		},

		naturalCompare (a, b, Factor) {
		  	if (a === undefined || b === undefined) {
		  	  return 0
			}

			let aChunks = typeof a === "number" ? [a] : a.trim().split(/(\d+)/).filter(Boolean).map(value => isNaN(Number(value)) ? value : Number(value))
			let bChunks = typeof b === "number" ? [b] : b.trim().split(/(\d+)/).filter(Boolean).map(value => isNaN(Number(value)) ? value : Number(value))

			let Index = 0
			let result = 0

			while (Index < aChunks.length && Index < bChunks.length && result === 0) {
				result = aChunks[Index] < bChunks[Index] ? -1 : result
				result = aChunks[Index] > bChunks[Index] ?  1 : result

				Index = Index + 1
			}

			result = (result === 0 ? aChunks.length - bChunks.length : result) * Factor

            return result
		},

		defaultValue (type, value) {
			switch (type) {
				case 'text':
					return typeof value === 'string' ? value : ''

				case 'int':
					return isNaN(parseInt(value)) ? 0 : parseInt(value)

				case 'float':
					return isNaN(parseFloat(value)) ? 0 : parseFloat(value)

				case 'date':
					return typeof value === 'string' ? value : null
			}

			return value
		},

		parse (type, value, column, model) {
			if (typeof column.type === 'function') {
				return column.type(value, column, model)
			}

			const result = this.defaultValue(type, value)

			switch (type) {
				case 'text':
					return result.split('\n')

				case 'int':
					return [parseInt(result)]

				case 'float':
					return [parseFloat(result)]

				case 'date':
					return [result === null ? null : moment(result, moment.ISO_8601).format('YYYY-MM-DD')]

				case 'null':
					return [null]

				default:
					return [result]
			}
		},

		setSortBy (filter) {
			var col

			this.sortAsc = !this.sortAsc

			if (this.sortBy !== filter) {
				this.sortAsc = true
			}

			this.sortBy = filter

			for (col in this.cols) {
				if (this.cols[col].json === this.sortBy) {
					this.cols[col].style = this.sortAsc === true ? 'fa fa-sort-asc' : 'fa fa-sort-desc'
				} else {
					this.cols[col].style = 'fa fa-sort'
				}
			}
		},

		selectAll (e) {
			let crit

			for (crit in this.criterias) {
				this.criterias[crit].checked = true
			}
		},

		selectNone (e) {
			let crit

			for (crit in this.criterias) {
				this.criterias[crit].checked = false
			}
		},

		selectInverse (e) {
			let crit

			for (crit in this.criterias) {
				this.criterias[crit].checked = !this.criterias[crit].checked
			}
		},

		clearSearch (e) {
			if (this.searchValue === '') {
				return
			}

			this.rowMeter = this.rowMeters[0]
			this.rowMeters = []
			this.searchValue = ''
		},

		parseCSS (aCol, aModel) {
			var result = aCol.colCSS

			if (typeof aCol.colCSS === 'function') {
				return aCol.colCSS(aCol, aModel)
			}

			return typeof aCol.colCSS === 'string' ? aCol.colCSS : null
		},

		parseStyle (aCol, aModel) {
			var result = aCol.colStyle

			if (typeof aCol.colStyle === 'function') {
				return aCol.colStyle(aCol, aModel)
			}

			return typeof aCol.colStyle === 'string' ? aCol.colStyle : null
		},

		toggleChecked (currCriteria) {
		 	currCriteria.checked = !currCriteria.checked;
		},

		sendMultiSelect () {
			const selectedItems = this.allModels.filter(Item => Item['_checked'])
			this.$emit('multiselect', selectedItems)
		}
	},

	computed: {
		rowSpanClass () {
			return this.rowButtonCount > 1 ? "input-group-btn" : ""
		},

		rowButtonCount  () {
			let count = 0

			count += this.hasDelButton ? 1 : 0
			count += this.hasEditButton ? 1 : 0
			count += this.hasRowAddButton ? 1 : 0
			count += this.hasSelectButton ? 1 : 0

			return count
		},

		selectedItemCount () {
			return this.filteredModel.reduce((Prev, Item) => {
				return Item['_checked'] ? Prev + 1 : Prev
			}, 0)
		},

		pageCount () {
			let result = 0

			if (this.rowMeter > 0) {
				result = Math.ceil(this.filteredModel.length / this.rowMeter)
			}

			if (this.page >= result && this.page > 0) {
				this.page = result - 1
			}

			return result
		},

		entryCount () {
			if (!this.rowMeterStarted) {
				this.rowMeterStarted = true
				if (this.filteredModel.length < 10) {
					this.rowMeter = 0
				}
			}
			return this.filteredModel.length
		},

		pageBefore () {
			let Index
			let result = []
			let IndexStr

			for (Index = this.page - 2; Index < this.page; Index = Index + 1) {
				if (Index >= 0) {
					IndexStr = '' + Index
					result.push(IndexStr)
				}
			}

			return result
		},

		pageAfter () {
			let Index
			let result = []

			for (Index = this.page + 1; Index < this.page + 3; Index = Index + 1) {
				if (Index < this.pageCount) {
					result.push(Index)
				}
			}

			return result
		},

		filteredModel () {
			// console.log("Collection: ", this.collection)

			if (typeof this.collection === 'undefined' || this.collection === null || this.collection.length === 0) {
				return []
			}

            let SearchFor = this.searchValue
				.split(',')
				.map(value => value.trim().toLowerCase())
				.filter(Value => Value !== "")

			let Cols = this.criterias
				.filter(value => value.checked)
				.map(value => value.json)

			if (this.sendCriteria) {
				let eventCriteria = {
					searchValue: this.searchValue,
					cols: Cols,
					sortAsc: this.sortAsc,
					sortCol: this.sortBy,
					andSearchMode: this.andSearchMode,
					completeValue: this.exactValue,
					caseSensitive: false,
					inclusiveSearchMode: this.inclusiveSearchMode
				}

				this.$store.commit("criteria", eventCriteria)
			}

			this.collection = this.collection.sort((a, b) => {
				return this.naturalCompare(a[this.sortBy], b[this.sortBy], this.sortAsc ? 1 : -1)
			})

			if (SearchFor.length === 0) {
				const finalResult = this.collection
				return finalResult
			} else {
				const finalResult = this.collection.filter(Item => {
					if (this.exactValue && !this.andSearchMode) {
						// Ganzes Wort, ODER-Modus
						const result = Cols.some(Col => SearchFor.some(Value => String(Item[Col]).toLowerCase() === Value))
						return this.inclusiveSearchMode ? result : !result
					} else if (!this.exactValue && !this.andSearchMode) {
						// Wort enthalten, ODER-Modus
						const result = Cols.some(Col => SearchFor.some(Value => String(Item[Col]).toLowerCase().indexOf(Value) > -1))
						return this.inclusiveSearchMode ? result : !result
					} else if (this.exactValue && this.andSearchMode) {
						// Ganzes Wort, UND-Modus
						const result = SearchFor.every(Value => Cols.some(Col => String(Item[Col]).toLowerCase() === Value))
						return this.inclusiveSearchMode ? result : !result
					} else if (!this.exactValue && this.andSearchMode) {
						// Wort enthalten, UND-Modus
						const result = SearchFor.every(Value => Cols.some(Col => String(Item[Col]).toLowerCase().indexOf(Value) > -1))
						return this.inclusiveSearchMode ? result : !result
					}

					return false
				})
				return finalResult
			}
		},

		allModels () {
			let result = this.filteredModel.map(Item => {
				let Result = Item
				Result['_visible'] = false
				// console.log('1', Item['name'])
				return Result
			})

			if (this.pageCount > 0) {
				result = result.slice(this.page * this.rowMeter, (this.page + 1) * this.rowMeter)
			}

			result = result.map(Item => {
				let Result = Item
				Result['_visible'] = true
				return Result
			})

			// this.$emit("modelChange", result)
			//this.$store.commit("modelchanged")
			console.log("The model has changed")

  			//result.forEach(Item => console.log(Item['_visible'], Item['_checked'], Item['name']))
			return result
			
			//this.$store.commit("allAreas", this.filteredModel)
			//return this.filteredModel
		},

		publicModels () {
			this.$emit("modelchanged", this.allModels)
			return this.allModels
		},

		hasSearch () {
			return !(typeof this.search === 'undefined')
		},

		hasSort () {
			// console.log(this.nosort);

			if (typeof this.nosort === 'undefined') {
				return true
			}

			return false
		},

		// Add-Button
		hasAddButton () {
			return !(typeof this.add === 'undefined')
		},

		searchClass () {
			return this.hasAddButton || this.hasPrintButton ? 'col-xs-10' : 'col-xs-12'
		},

		// Events für einzelne Zeilen
		hasEditButton () {
			return !(typeof this.edit === 'undefined')
		},

		hasDelButton () {
			return !(typeof this.delete === 'undefined')
		},

		hasSelectButton () {
			return !(typeof this.select === 'undefined')
		},

		hasRowAddButton () {
			return !(typeof this.rowAdd === 'undefined')
		},

		hasRowButtons () {
			return this.hasEditButton || this.hasDelButton || this.hasSelectButton || this.hasRowAddButton
		},

		addURL () {
			return typeof this.add === 'undefined' ? '' : this.add
		},

		editURL () {
			return typeof this.edit === 'undefined' ? '' : this.edit
		},

		selURL () {
			return typeof this.select === 'undefined' ? '' : this.select
		},

		delURL () {
			return typeof this.delete === 'undefined' ? '' : this.delete
		},

		colCount () {
			return this.hasRowButtons ? this.cols.length + 1 : this.cols.length
		},

		// Add-Button
		hasPrintButton () {
			return !(typeof this.print === 'undefined')
		},

		hasMultiSelect () {
			return !(typeof this.multiselect === 'undefined')
		},

		multiselectText () {
  			return typeof this.multiselect === 'string' && this.multiselect.trim() === '' ? 'Auswählen' : this.multiselect.trim()
		},

		checkClass () {
			const allChecked = this.allModels.every(Item => Item['_checked'])
			const someChecked = this.allModels.some(Item => Item['_checked'])

			if (this.allModels.length === 0) {
				return 'fa fa-square-o'
			} else if (allChecked) {
				return 'fa fa-check-square-o'
			} else if (someChecked) {
				return 'fa fa-minus-square-o'
			} else {
				return 'fa fa-square-o'
			}
		},

		selectText () {
			const counted = this.allModels.reduce((Sum, Item) => {
				return Item['_checked'] ? Sum + 1 : Sum
			}, 0)

			const hiddenCounted = this.collection.reduce((Sum, Item) => {
				return Item['_checked'] ? Sum + 1 : Sum
			}, 0) - counted

  			const countedText = counted + ' ausgewählt'
  			const hiddenText = hiddenCounted === 0 ? '' : ', ' + hiddenCounted + ' verborgen'

			return counted === 0 && hiddenCounted === 0 ? '' : '(' + countedText + hiddenText + ')'
		}

		// Raum für neue Eigenschaften
	},

	filters: {
		parseURL (url, model) {
			let Property
			let result = url

			if (url === null || model === null) {
				return result
			}

			for (Property in model) {
				if (model.hasOwnProperty(Property)) {
					result = result.replace('{:' + Property + '}', model[Property])
				}
			}

			return result
		}
	}
}
</script>

<style>
	th {
		-webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Safari*/
		-khtml-user-select: none; /* Konqueror */
		-moz-user-select: none; /* Firefox */
		-ms-user-select: none; /* Internet Explorer/Edge */
		user-select: none;
	}

	.custom_tooltip {
		position: relative;
		display: inline-block;
		border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
		font-weight: normal;
	}

	/* Tooltip text */
	.custom_tooltip .custom_tooltiptext {
		visibility: hidden;
		width: 150px;
		background-color: black;
		color: #fff;
		text-align: center;
		border-radius: 6px;
		padding: 5px 0;
		position: absolute;
		z-index: 1;
		top: 150%;
		left: 50%;
		margin-left: -60px;
		padding: 5px;
		font-size: 1em;
	}

	/* Show the tooltip text when you mouse over the tooltip container */
	.custom_tooltip:hover .custom_tooltiptext {
		visibility: visible;
	}

	.custom_tooltip .custom_tooltiptext::after {
		content: " ";
		position: absolute;
		bottom: 100%;  /* At the top of the tooltip */
		left: 50%;
		margin-left: -5px;
		border-width: 5px;
		border-style: solid;
		border-color: transparent transparent black transparent;
	}
</style>



// WEBPACK FOOTER //
// custom-table.vue?24f3ae2f